import router from '@/router';
export default {
  state: {
    writeoffActivityList: [],
    writeoffCategoryList: [],
    writeoffCouponCount: '',
    writeoffActivityCount: '',
  },
  getters: {},
  mutations: {
    setWriteOffListByActivity (state: any, data: any) {
      state.writeoffActivityList = data.list || [];
    },
    setWriteOffListByCategory (state: any, data: any) {
      state.writeoffCategoryList = data.list || [];
    },
    setWriteOffCouponCount (state: any, data: any) {
      state.writeoffCouponCount = data || '';
    },
    setWriteOffActivityCount (state: any, data: any) {
      state.writeoffActivityCount = data || '';
    },
  },
  actions: {
    async getWriteOffListByActivity ({ commit }: any, params: any) { // 按活动核销统计
      const { error, success }: any = await router.app.$request('WRITEOFF_ACTIVITY_LIST', params);
      success && commit('setWriteOffListByActivity', success.data);
      return { error, success };
    },
    async getWriteOffListByCategory ({ commit }: any, params: any) { // 按券核销统计
      const { error, success }: any = await router.app.$request('WRITEOFF_CATEGORY_LIST', params);
      success && commit('setWriteOffListByCategory', success.data);
      return { error, success };
    },
    async getWriteOffCouponCount ({ commit }: any, params: any) { // 主体下领取和核销的券数量接口
      const { error, success }: any = await router.app.$request('WRITEOFF_COUPON_COUNT', params);
      success && commit('setWriteOffCouponCount', success.data);
      return { error, success };
    },
    async getWriteOffActivityCount({ commit }: any, params: any) { // 活动数
      const { error, success }: any = await router.app.$request('WRITEOFF_ACTIVITY_COUNT', params);
      success && commit('setWriteOffActivityCount', success.data);
      return { error, success };
    },
    async getDayOrMonthCount({ commit }: any, params: any) { // 统计指定主体最近7天或者最近6个月的核销数接口
      const { error, success }: any = await router.app.$request('DAYORMONTH_WRITEOFF_COUNT', params);
      return { error, success };
    },
  }
}
